import { render, staticRenderFns } from "./infoDetails.vue?vue&type=template&id=cca9ee56&scoped=true"
import script from "./infoDetails.vue?vue&type=script&lang=js"
export * from "./infoDetails.vue?vue&type=script&lang=js"
import style0 from "./infoDetails.vue?vue&type=style&index=0&id=cca9ee56&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_bbcd016e015477a3ecf09e87b6c3f580/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca9ee56",
  null
  
)

export default component.exports